import { DEFAULT_BUTTON_VALUE } from 'constants/checkout/errorMessages';
import urls from 'constants/urls';
import { openModal } from 'redux/modules/common-modal/actions';
import { preserveStubsUrl } from 'utils/general';
import locator from 'utils/locator';

export default errorResponse => dispatch => {
  const status = errorResponse?.status;
  const code = errorResponse?.response?.body?.code;

  if (status === 409 && code === 'ORDER_ORCHESTRATION_017') {
    const onCloseCallback = () => {
      locator.href = preserveStubsUrl(urls.serviceSelection);
    };

    dispatch(
      openModal({
        id: 'checkout-error-book-slot',
        severity: 'conflict',
        buttons: [
          {
            buttonText: 'Book a slot',
            buttonValue: DEFAULT_BUTTON_VALUE,
            primary: true,
          },
        ],
        cannotClose: true,
        messageText: ['To checkout, you must book a slot.'],
        titleText: 'You still need to book a slot',
        webview: {
          id: 'checkout-error-13',
          ctas: [urls.serviceSelection],
        },
        useIngredientsModal: false,
        onCloseCallback,
      }),
    );

    return true;
  }

  return false;
};
